<template>
  <a-config-provider :locale="locale" :auto-insert-space-in-button="false">
    <common-layout />
  </a-config-provider>
</template>

<script>
import { debounce } from 'throttle-debounce'
import { mapMutations } from 'vuex'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import { initMainState, actions } from './microAppsConfig'
import CommonLayout from '@/layouts/CommonLayout'

export default {
  components: {
    CommonLayout
  },
  data () {
    return {
      locale: zhCN
    }
  },
  mounted () {
    initMainState()
    this.BODY_WIDTH(document.body.clientWidth)
    this.BODY_HEIGHT(document.body.clientHeight)
    actions.setGlobalState({ clientWidth: document.body.clientWidth })
    window.addEventListener('resize', debounce(600, () => {
      this.BODY_WIDTH(document.body.clientWidth)
      this.BODY_HEIGHT(document.body.clientHeight)
      actions.setGlobalState({ clientWidth: document.body.clientWidth })
    }))
  },
  methods: {
    ...mapMutations(['BODY_WIDTH', 'BODY_HEIGHT'])
  }
}
</script>
<style>
  #app.benchApp {
    min-width: 1200px;
    height: 100%;
    min-height: 520px;
  }
</style>
